import React, { Fragment, useEffect, useRef } from 'react';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import Link from 'chameleon/ui-stack/ui/base/link';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import { connectLean } from 'lean-redux';

const PDFStatus = ({
  visibilityToStudents,
  sharedWith,
  savedClassesWithName,
  ...props
}) => {
  useEffect(() => {
    const savedClasses = (savedClassesWithName || sharedWith)?.map((c) =>
      Number(c.id),
    );

    if (savedClasses && !props.savedClasses) {
      props.setSavedClasses(savedClasses);
      props.setSelectedItems(savedClasses);
    }
  }, []);

  if (visibilityToStudents === 'AlwaysShow') {
    return <span className="whitespace-nowrap">Always Visible</span>;
  }

  const popoverContentRef = useRef();

  const onOpen = () => {
    if (popoverContentRef.current) {
      popoverContentRef.current.focus();
    }
  };

  if ((savedClassesWithName || sharedWith)?.length) {
    return (
      <PopOver trigger={<Link>Shared</Link>} size="medium" onOpen={onOpen}>
        <div ref={popoverContentRef}>
          <span className="font-medium">Shared with: </span>
          {(savedClassesWithName || sharedWith)
            .map((section) => section.name)
            .join(', ')}
        </div>
      </PopOver>
    );
  }

  return <Fragment>Not Shared</Fragment>;
};

export default withApollo(
  withRouter(
    connectLean({
      mapState(state) {
        const {
          selectedItems,
          savedClasses,
          cachedAssignData,
          savedClassesWithName,
        } = state;

        return {
          selectedItems,
          savedClasses,
          cachedAssignData,
          savedClassesWithName,
        };
      },
      setSavedClasses(items) {
        this.setState({
          savedClasses: items,
        });
      },
      setSelectedItems(items) {
        this.setState({
          selectedItems: items,
        });
      },
    })(PDFStatus),
  ),
);
